'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as"];
import React from 'react';
import { spacer12 } from '@spotify-internal/encore-foundation';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { cssSpacing } from "../../styles/index.mjs";
import { TypeList } from "../TypeList/index.mjs";
import styled from "../../styled-components.mjs";
var NavBarListElement = styled(TypeList).attrs({
  condensedAll: true,
  listStyleReset: true
}).withConfig({
  displayName: "NavBarList__NavBarListElement",
  componentId: "sc-19lzbdt-0"
})(["display:flex;margin-block-end:", ";overflow-x:auto;overflow-wrap:break-word;padding:", ";-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"], cssSpacing('tighter', spacer12), cssSpacing('tighter-5', '2px'));

/**
* **NavBarList** ![Status: Production](https://img.shields.io/badge/PRODUCTION-%2357B560|height=14)
*
* [GitHub](https://ghe.spotify.net/encore/web/tree/master/src/core/components/NavBarList) | [Figma](https://www.figma.com/file/bnQXqGkLeiTlbk8JXGDcsX/Encore-Web---Light-Theme-Toolkit?node-id=20339:15819)
*
* null
*
* [Read the full component documentation →](https://encore.spotify.net/web/components/navigation?format=figma-figma#nav-bar)
*
* @example
* () => <NavBarList />;
*
*/
/**
 * @deprecated
 * This component will be archived soon.
 * Use the TabsList component with instead.
 */
export var NavBarList = /*#__PURE__*/React.forwardRef(function NavBarList(_ref, ref) {
  var as = _ref.as,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(NavBarListElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    "data-encore-id": ENCORE_DATA_IDS.NavBarList
  }));
});